import React from 'react';
import { Stack } from '@hub/stack';
import { Text } from '@hub/text';
import { Box } from '@hub/box';
import { Link } from '@hub/link';
import { useToken } from '@hub/design-system-base';
import { CloudinaryImage, IMAGE_SIZES_SLIM_CARD_HERO } from '../cloudinary-image';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ColorCardSlim = _ref => {
  var _heroImageSet$masterS;

  let {
    banner,
    termsAndConditionsLink
  } = _ref;
  const {
    title,
    bodyCopy,
    heroImageSet
  } = banner;
  const heroImageUrl = heroImageSet === null || heroImageSet === void 0 ? void 0 : heroImageSet.master.url;
  const supportingColour = (_heroImageSet$masterS = heroImageSet === null || heroImageSet === void 0 ? void 0 : heroImageSet.masterSupportingColour) !== null && _heroImageSet$masterS !== void 0 ? _heroImageSet$masterS : 'smoke';
  const squareImagePadding = useToken('space', 'spacing-md');
  const heroImageExist = (banner === null || banner === void 0 ? void 0 : banner.heroImageSet) && heroImageUrl;
  return /*#__PURE__*/_jsxs(Stack, {
    direction: "column",
    "data-id": "color-cards-slim_index_ColorCardSlim_Stack",
    children: [/*#__PURE__*/_jsxs(Stack, {
      gap: ['spacing-3', 'spacing-4', 'spacing-5'],
      direction: "row",
      shouldWrapChildren: false,
      sx: {
        alignItems: ['left', 'left', 'top'],
        backgroundColor: supportingColour,
        padding: squareImagePadding
      },
      "data-id": "color-cards-slim_index_ColorCardSlim_Stack_Stack_1",
      children: [heroImageExist && /*#__PURE__*/_jsx(Box, {
        className: style.heroImage,
        "data-id": "color-cards-slim_index_ColorCardSlim_Box",
        children: /*#__PURE__*/_jsx(CloudinaryImage, {
          ratio: "1",
          imageSetOrImage: {
            url: heroImageUrl,
            alt: title,
            type: 'SQUARE'
          },
          resizeMode: "pad",
          sizes: IMAGE_SIZES_SLIM_CARD_HERO,
          "data-id": "color-cards-slim_index_ColorCardSlim_Box_CloudinaryImage"
        })
      }), /*#__PURE__*/_jsx(Stack, {
        shouldWrapChildren: false,
        sx: {
          padding: ['none', 'spacing-md', 'spacing-md', 'spacing-lg'],
          paddingLeft: ['0px', '0px', '0px', 'spacing-lg']
        },
        direction: "row",
        align: "center",
        "data-id": "color-cards-slim_index_ColorCardSlim_Stack_Stack",
        children: /*#__PURE__*/_jsxs(Box, {
          className: style.title,
          sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
          },
          "data-id": "color-cards-slim_index_ColorCardSlim_Stack_Box",
          children: [/*#__PURE__*/_jsx(Text, {
            isBodyText: true,
            as: 'h1',
            fontSize: ['font-h4', 'font-h3', 'font-h2', 'font-h1'],
            tone: "strong",
            "data-id": "color-cards-slim_index_ColorCardSlim_Box_Text",
            children: title
          }), /*#__PURE__*/_jsx(Box, {
            className: style.desktopDescription,
            "data-id": "color-cards-slim_index_ColorCardSlim_Box_Box",
            children: /*#__PURE__*/_jsx(Stack, {
              direction: "row",
              shouldWrapChildren: false,
              sx: {
                color: 'quartz',
                gap: ['16px', '16px', '24px'],
                maxWidth: '90%',
                margin: '0 auto'
              },
              "data-id": "color-cards-slim_index_ColorCardSlim_Box_Stack",
              children: /*#__PURE__*/_jsxs(Text, {
                isBodyText: true,
                color: "licorice",
                "data-id": "color-cards-slim_index_ColorCardSlim_Stack_Text",
                children: [bodyCopy && "".concat(bodyCopy, " "), termsAndConditionsLink && /*#__PURE__*/_jsx(Link, {
                  hasUnderline: true,
                  href: termsAndConditionsLink,
                  "data-id": "color-cards-slim_index_ColorCardSlim_Link",
                  children: "See T&Cs for details."
                })]
              })
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      className: style.mobileDescription,
      sx: {
        backgroundColor: supportingColour,
        padding: squareImagePadding,
        paddingTop: '0px'
      },
      "data-id": "color-cards-slim_index_ColorCardSlim_Stack_Box",
      children: [bodyCopy && /*#__PURE__*/_jsxs(Text, {
        isBodyText: true,
        color: "licorice",
        "data-id": "color-cards-slim_index_ColorCardSlim_Text",
        children: [bodyCopy, ' ']
      }), termsAndConditionsLink && /*#__PURE__*/_jsx(Link, {
        hasUnderline: true,
        href: termsAndConditionsLink,
        "data-id": "color-cards-slim_index_ColorCardSlim_Link",
        children: "See T&Cs for details."
      })]
    })]
  });
};